import React, { useEffect, useState } from "react";
import { Container, Card } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdAddPhotoAlternate, MdDelete, MdEdit } from "react-icons/md";
import { IconButton } from "@mui/material";
import { Button, Input, Spin, Modal, Select, Switch, Pagination } from "antd";
import { getValue, phoneFormat } from "../../../services/functions";
import CountUp from "react-countup";
import { Message, ViewInput } from "../../../GlobalStyles";
import { ExclamationCircleFilled } from "@ant-design/icons";

const { confirm } = Modal;

export default function Atendentes() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [enabled, setEnabled] = useState(true);
  const [attendants, setAttendants] = useState([]);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [attendantsTotal, setAttendantsTotal] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [photo, setPhoto] = useState("");
  const [page, setPage] = useState(0);
  const [password, setPassword] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    listAtendentes();
  }, []);

  async function listAtendentes() {
    setLoading(true);
    await api
      .get(`/attendants`)
      .then((response) => {
        setAttendants(response.data.attendants);
        setAttendantsTotal(response.data.attendantsTotal);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function createAndEditAtendente() {
    setIsLoadingModal(true);
    if (id) {
      if (!name || !email) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("password", password);
        data.append("enabled", enabled);
        data.append("email", email);
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .put(`/attendant/${id}`, data)
          .then(async (ok) => {
            toast.success("Atendente editado com sucesso");
            listAtendentes();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      }
    } else {
      if (!name || !email || !password) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("password", password);
        data.append("enabled", enabled);
        data.append("email", email);
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .post(`/attendant`, data)
          .then(async (ok) => {
            toast.success("Atendente criado com sucesso");
            listAtendentes();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteTecnico(id) {
    await api
      .delete(`/attendant/${id}`)
      .then(() => {
        toast.success("Atendente excluido com sucesso");
        listAtendentes();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Atendentes</h1>

      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={attendantsTotal} />
          </Card>
          <div className="filter">
            <ViewInput style={{ width: 300 }}>
              <p>Pesquisar</p>
              <Input.Search
                value={filter}
                onChange={(text) => {
                  setFilter(text.target.value);
                }}
                placeholder="pesquisar"
                onSearch={(text) => {
                  setFilterSearch(text);
                  if (page) {
                    setPage(0);
                  }
                }}
                allowClear
                onClear={() => {
                  setFilterSearch("");
                  setFilter("");
                  if (page) {
                    setPage(0);
                  }
                }}
                enterButton
              />
            </ViewInput>
            <Button
              type="primary"
              style={{
                marginTop: 17,
                marginLeft: 50,
                borderRadius: 50,
              }}
              onClick={() => {
                setId("");
                setName("");
                setEmail("");
                setEnabled(true);
                setPassword("");
                setPhoto("");
                setVisibleModal(true);
              }}
            >
              Novo Atendente
            </Button>
          </div>
          {attendants.length == 0 && (
            <Message>Nenhum atendente encontrado</Message>
          )}
          <div className="orders">
            {attendants.map((item) => {
              return (
                <div className="order">
                  <img
                    src={
                      item.photo
                        ? item.photo_url
                        : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__480.png"
                    }
                  />
                  <div className="infos">
                    <p>{item.name}</p>
                    <p style={{ color: "#0008", marginTop: 5 }}>{item.email}</p>
                    <p style={{ color: "#000a", marginTop: 5 }}>
                      {item.enabled
                        ? "Habilitado para Atendimento"
                        : "Não Habilitado para Atendimento"}
                    </p>
                  </div>
                  <div className="actions">
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate(`/admin/chamados?atendente=${item.id}`);
                      }}
                    >
                      Chamados
                    </Button>
                    <Button
                      type="primary"
                      className="warning-button"
                      onClick={() => {
                        setId(item.id);
                        setName(item.name);
                        setEmail(item.email);
                        setEnabled(item.enabled);
                        setPhoto({ photo_url: item.photo_url });
                        setPassword("");
                        setVisibleModal(true);
                      }}
                    >
                      <MdEdit color="#FFF" size={20} />
                      Editar
                    </Button>
                    <Button
                      type="primary"
                      className="delete-button"
                      onClick={() => {
                        confirm({
                          okText: "Confirmar",
                          title: `Deseja excluir o Atendente ${item.name}?`,
                          icon: <ExclamationCircleFilled />,
                          content: `O atendente será excluido e perderá o acesso ao sistema`,
                          onOk() {
                            deleteTecnico(item.id);
                          },
                          onCancel() {},
                          cancelText: "Cancelar",
                        });
                      }}
                    >
                      <MdDelete color="#FFF" size={20} />
                      Exluir
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>

          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={attendantsTotal}
          />
        </>
      )}

      <Modal
        title="Atendente"
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={id ? "EDITAR ATENDENTE" : "CADASTRAR ATENDENTE"}
        cancelText="FECHAR"
        onOk={() => {
          createAndEditAtendente();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              marginTop: 0,
              width: 260,
              height: 160,
              borderRadius: 10,
              marginBottom: 25,
              marginBottom: 20,
              justifyContent: "center",
            }}
          >
            <img
              style={{
                width: 160,
                marginLeft: 50,
                height: 160,
                borderRadius: 10,
                background: "#fff",
              }}
              src={
                photo.photo_url
                  ? photo.photo_url
                  : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__480.png"
              }
            />
            <IconButton style={{ width: 50, height: 50, bottom: 15 }}>
              <label
                for="avatar"
                style={{
                  display: "flex",
                  width: 50,
                  height: 50,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <MdAddPhotoAlternate color="#000" />
                <input
                  id="avatar"
                  style={{ display: "none" }}
                  type="file"
                  accept="image/"
                  onChange={(file) => {
                    let photo = file.target.files[0];
                    photo.photo_url = URL.createObjectURL(file.target.files[0]);
                    setPhoto(photo);
                  }}
                />
              </label>
            </IconButton>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <ViewInput>
              <p>Nome*</p>
              <Input
                placeholder="nome"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Email*</p>
              <Input
                placeholder="suario@gmail.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>{id ? "Nova Senha" : "Senha*"}</p>
              <Input
                placeholder={"****"}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </ViewInput>
            <ViewInput
              style={{
                width: "49%",
              }}
            >
              <p>Atendimento Habilitado?</p>
              <div style={{ width: "100%", display: "flex" }}>
                <Switch
                  type="primary"
                  value={enabled}
                  style={{ justifySelf: "flex-start" }}
                  onChange={(text, type) => {
                    setEnabled(!enabled);
                  }}
                />
              </div>
            </ViewInput>
          </div>
        </div>
      </Modal>
    </Container>
  );
}
